import React, { useEffect, useState } from 'react'
import ReactModal from 'react-modal'
import '../../../styles/modals/SingleResultModal.css'
import { ReactComponent as DropDownSurvey } from '../../../assets/svg/dropdownSurvey.svg'
import { ReactComponent as DropUpSurvey } from '../../../assets/svg/dropupSurvey.svg'
import { ReactComponent as CloseModalIcon } from '../../../assets/svg/CloseModalIcon.svg'
import { useTranslation } from 'react-i18next'
import { fileSystemUrl, videoUrl } from '../../../constants/Connections'
import { useUser } from '../../../auth'
import i18n from '../../../i18n'
import ImageWithPlaceholder from '../../dashboard/components/ImageWithPlaceholder'
import { format_day, translateTargetText } from '../../../utils/util'
import { ReactComponent as NotFoundIcon } from '../../../assets/svg/NotFoundIcon.svg'
import { BarColors } from '../../../constants/BarColors'
import { ANALYTICS_EVENTS } from '../../../analytics/events'
import useTrackedSurface from '../../../analytics/useTrackedSurface'

function ContentDetailsModal({ content, modalIsOpen, closeModal }) {
    const { t } = useTranslation()
    const { user } = useUser()
    const type = content?.type
    useTrackedSurface(ANALYTICS_EVENTS.ANALYTICS_CONTENT_DETAILS_VIEWED, {
        active: modalIsOpen,
        contentId: content?.id,
        content: content?.title,
    })

    useEffect(() => {
        if (modalIsOpen) {
            ReactModal.setAppElement('#root')
            document.getElementById('home').style.filter = 'blur(5px)'
        } else {
            document.getElementById('home').style.filter = 'unset'
        }
    }, [modalIsOpen])

    const hasImage = !!content?.files
    const isVideo = content?.files?.type === 'video'
    const mediaUrl = hasImage ? `${isVideo ? videoUrl : fileSystemUrl}/${content?.files?.storage_name}?token=${user.token}` : ''

    return (
        <ReactModal
            transparent
            closeTimeoutMS={600}
            isOpen={modalIsOpen}
            onAfterOpen={() => {}}
            onAfterClose={() => {}}
            className="noScroll"
            style={{
                overlay: {
                    zIndex: 0,
                },
                content: {
                    padding: 0,
                    opacity: 1,
                    width: 1000,
                    margin: 'auto',
                    backgroundColor: 'transparent',
                    maxHeight: '100%',
                    border: 'none',
                    boxShadow: 'none',
                    overflow: 'scroll',
                    paddingTop: 35,
                    paddingBottom: 35,
                },
            }}
        >
            <div className="w-full bg-white p-[35px] mt-[30px] rounded-[10px]">
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div className="close-modal-icon " onClick={closeModal}>
                        <CloseModalIcon />
                    </div>
                </div>
                <div>
                    <div>
                        <div className="flex flex-row gap-5 ">
                            {/* {content?.files && <div>{showImage(content?.files, 150)}</div>} */}
                            {hasImage &&
                                (isVideo ? (
                                    <div className="simage-container-new min-w-[200px] !max-w-[200px]">
                                        <video controls controlsList="nodownload">
                                            <source src={mediaUrl} />
                                            {t('yourBrowserDoesNotSupportHTMLVideo')}
                                        </video>
                                    </div>
                                ) : (
                                    <div
                                        className=" min-w-[150px] !max-w-[150px] pointer"
                                        style={{
                                            marginRight: i18n.language == 'ar' ? 0 : 20,
                                            marginLeft: i18n.language == 'ar' ? '20' : 0,
                                        }}
                                        // onClick={() => openBigImage(imgUrl)}
                                    >
                                        <ImageWithPlaceholder url={mediaUrl} altText={content?.title} width={150} />
                                    </div>
                                ))}
                            <div className="flex-1">
                                <div className="flex justify-between items-center">
                                    <span className="text-mudPurple font-medium text-sm">
                                        <span className="text-[#9392ad99]">{t('target')}:</span> {translateTargetText(content?.target_text)}
                                    </span>
                                    <p>
                                        <span className="text-[#9392ad99] font-medium text-sm">
                                            {t('date')} & {t('time')}:{' '}
                                        </span>
                                        <span className="text-mudPurple font-medium text-sm">{format_day(content?.publicationDate, true, i18n.language)}</span>
                                    </p>
                                </div>
                                <div className="single-content-body my-3 flex justify-between items-start">
                                    <h2 className="text-deepPurple font-bold text-xl text-left max-w-xl">{content?.title}</h2>
                                </div>
                                <p className="text-sm text-mudPurple text-left mt-3">{content?.message ?? content?.description}</p>
                            </div>
                        </div>
                        <div>
                            {!!content?.answer_data?.length ? (
                                <div>
                                    <h2 className="font-bold text-xl  text-deepPurple text-left mt-4">{t('answer')} </h2>
                                    {content.anonymous && (
                                        <div className="flex justify-center w-full flex-col items-center my-10">
                                            <NotFoundIcon />
                                            <span className="text-base text-deepPurple font-bold mt-5">
                                                {t('This content is anonymous, so you won’t be able to see any responses')}{' '}
                                            </span>
                                        </div>
                                    )}
                                    {!content.anonymous && (
                                        <div>
                                            {['poll', 'question'].includes(content?.type) &&
                                                content?.answer_data?.map((answer, index) => {
                                                    return (
                                                        <div className={`bg-containerGray w-full  py-2 px-2 flex items-center justify-start text-left my-2 rounded-xl`} key={index}>
                                                            <div
                                                                className="min-w-[10px] h-[10px] rounded-full mr-3"
                                                                style={{
                                                                    background: BarColors[0],
                                                                }}
                                                            ></div>
                                                            <div className="flex flex-col justify-between max-w-[calc(100%-22px)]">
                                                                <p className="text-sm text-mudPurple w-full break-words">{answer}</p>
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                            {type === 'survey' &&
                                                content?.answer_data?.map((section, index) => {
                                                    return (
                                                        <div className="bg-whiteContrast p-4 rounded-xl my-5" key={index}>
                                                            <h3 className="text-left text-mudPurple text-lg font-semibold">{section?.title}</h3>
                                                            <p className="text-left text-sm text-mudPurple mt-2">{section?.description}</p>
                                                            <div>
                                                                {section?.questions?.map((question, qi) => {
                                                                    return <ContentSurveyQuestion question={question} qi={qi} index={index} key={qi} />
                                                                })}
                                                            </div>
                                                        </div>
                                                    )
                                                })}
                                        </div>
                                    )}
                                </div>
                            ) : (
                                <div className="flex justify-center w-full flex-col items-center my-10">
                                    <NotFoundIcon />
                                    <span className="text-base text-deepPurple font-bold mt-5">{t('No responses yet — check back soon!')} </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </ReactModal>
    )
}

export default ContentDetailsModal

const ContentSurveyQuestion = ({ question, qi, index }) => {
    const [isExpanded, setIsExpanded] = useState(false)
    const { t } = useTranslation()
    return (
        <div key={qi} className={`p-4 rounded-xl my-5 ${isExpanded ? 'bg-lightBG' : 'bg-[#f4f4fc]'}`}>
            <div className="flex flex-row justify-between items-start">
                <div className="max-w-[45rem]">
                    <h3 className="font-bold text-deepPurple text-xl text-left">
                        {index + 1}. {qi + 1}. {question?.title}
                    </h3>
                    {question.type === 'openAnswer' && <p className="text-left text-sm mt-2 text-mudPurple">{t('open_question')} </p>}
                    {!!question?.description && <p className="text-left text-sm mt-2 text-mudPurple">{}</p>}
                </div>
                <div
                    className={`pointer rounded-full w-[56px] h-[56px] flex items-center justify-center ${isExpanded ? 'bg-deselectPurple' : 'border border-deselectPurple'}`}
                    onClick={() => setIsExpanded(!isExpanded)}
                >
                    {isExpanded ? <DropUpSurvey /> : <DropDownSurvey />}
                </div>
            </div>

            {isExpanded && (
                <div>
                    <h2 className="font-bold text-xl  text-deepPurple text-left mt-4">{t('answer')} </h2>
                    <div>
                        <div className="bg-containerGray w-full py-2 px-2 flex items-center justify-start text-left my-2 rounded-xl">
                            <div
                                className="w-[10px] h-[10px] rounded-full mr-3"
                                style={{
                                    background: BarColors[0],
                                }}
                            ></div>
                            <div className="flex flex-col justify-between">
                                <p className="text-sm text-mudPurple">{question?.answer}</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
}
